import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitorUpfrontRegistrationActionBarComponent } from './component/visitor-upfront-registration-action-bar.component';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonUIElementsModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [
    VisitorUpfrontRegistrationActionBarComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    CommonLayoutModule,
    CommonTranslationModule,
    CommonUIElementsModule
  ]
})
export class VisitorUpfrontRegistrationActionBarModule { }
